import { render, staticRenderFns } from "./modalEditAutomatedNotification.vue?vue&type=template&id=b5af0766&"
import script from "./modalEditAutomatedNotification.vue?vue&type=script&lang=js&"
export * from "./modalEditAutomatedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports